"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var VideoFill = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M14.4995,5 C15.3265,5 15.9995,5.673 15.9995,6.5 L15.9995,6.5 L15.9995,17.5 C15.9995,18.327 15.3265,19 14.4995,19 L14.4995,19 L3.4995,19 C2.6725,19 1.9995,18.327 1.9995,17.5 L1.9995,17.5 L1.9995,6.5 C1.9995,5.673 2.6725,5 3.4995,5 L3.4995,5 Z M20.4615,6.741 C20.7695,6.546 21.1595,6.532 21.4805,6.707 C21.8005,6.883 22.0005,7.219 22.0005,7.584 L22.0005,7.584 L22.0005,16.416 C22.0005,16.778 21.8025,17.113 21.4855,17.29 C21.3345,17.374 21.1675,17.416 20.9995,17.416 C20.8155,17.416 20.6325,17.365 20.4715,17.266 L20.4715,17.266 L17.0005,15.105 L17.0005,8.951 Z", fillRule: "evenodd" })));
};
VideoFill.displayName = 'VideoFill';
exports.default = VideoFill;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=VideoFill.js.map